import { Box, Button, Image, Typography } from "@jewlr/storybook/core"
import { Checkbox } from "@jewlr/storybook/form"
import React, { useState } from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

const Text = styled(Typography).attrs({
  fontSize: "16px",
  fontWeight: "500",
  letterSpacing: "-0.02em",
  lineHeight: "20px",
})``

const StyledLink = styled(Link)`
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.02em;
  line-height: 21px;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`

const GetStarted = styled(Button).attrs({
  mt: "30px",
  mx: "auto",
  variant: "primary",
})`
  border-radius: 5px;
  display: block;
  height: 48px;
  padding: 14px 48px;
  &:disabled {
    background-color: #757575;
  }
`

const FORM_URL = "https://forms.gle/bEWM2RNp3zew5L959"

const Partnerships = () => {
  const [acceptedTerms, setAcceptedTerms] = useState(false)

  return (
    <>
      {/* <Picture
        alt="Safyre Labs brands"
        fallback={require("images/info/partnerships/safyre-labs-brands-desktop.jpg")}
        srcSet={[
          {
            height: "62",
            media: "(max-width: 767px)",
            sizes: "100vw",
            srcSet: `${require("images/info/partnerships/safyre-labs-brands-mobile.jpg")} 375w, ${require("images/info/partnerships/safyre-labs-brands-mobile_2x.jpg")} 750w`,
            width: "375",
          },
          {
            height: "239",
            media: "(min-width: 768px)",
            sizes: "100vw",
            srcSet: `${require("images/info/partnerships/safyre-labs-brands-desktop.jpg")} 1440w, ${require("images/info/partnerships/safyre-labs-brands-desktop_2x.jpg")} 2880w`,
            width: "1440",
          },
        ]}
      /> */}
      <Box contain pb={8} px={4} textAlign="center">
        <Typography
          as="h1"
          fontSize="38px"
          fontWeight="700"
          lineHeight="42px"
          mb={2}
          mt={8}
        >
          Partnerships
        </Typography>
        <Text mb={6}>
          We believe in authentic, long-lasting, mutually beneficial
          relationships with creators and brands and are always looking for new
          partners to work with. If you are interested in a potential
          partnership, we would love to hear from you!
        </Text>
        <Box>
          <Checkbox
            checked={acceptedTerms}
            labelStyle={{ ml: "10px" }}
            onChange={() => setAcceptedTerms(!acceptedTerms)}
            style={{ flexShrink: 0 }}
            value={acceptedTerms}
          >
            <Text textAlign="left">
              I accept and agree to the{" "}
              <Box
                as="span"
                className="nowrap"
                display={{ _: "block", desktop: "inline-block" }}
              >
                <StyledLink
                  data-lc="partnetships"
                  target="_blank"
                  to="/info/privacy-policy"
                >
                  Privacy Policy
                </StyledLink>{" "}
                and{" "}
                <StyledLink
                  data-lc="partnetships"
                  target="_blank"
                  to="/info/terms-conditions"
                >
                  Terms and Conditions
                </StyledLink>
              </Box>
            </Text>
          </Checkbox>
        </Box>
        <GetStarted
          disabled={!acceptedTerms}
          onClick={() => window.open(FORM_URL, "_blank")}
        >
          Get Started
        </GetStarted>
        <Image
          alt={sl.config.site_title}
          height="30px"
          mt="80px"
          src={require("images/logo/safyre_labs.svg")}
          width="225px"
        />
      </Box>
    </>
  )
}

export default Partnerships
